import CustomCheckbox from "../CustomCheckbox";
import { showGrade } from "../../utils/textUtils";
import ErrorIcon from "@mui/icons-material/Error";

const SelectedStudentList = ({
  selectedStudents,
  handleAddStudents,
  handleSelectStudent,
  handleSelectAllStudent,
  isEditMode = false,
}) => {
  return (
    <div>
      <div style={{ margin: "10px 0px" }}>
        선택된 학생 ({selectedStudents.length})
      </div>
      <button
        style={{
          padding: "10px",
          backgroundColor: "#2D2D2D",
          color: "#FFFFFF",
          fontSize: "16px",
          fontWeight: "bold",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          width: "100%",
        }}
        onClick={selectedStudents.length > 0 ? handleAddStudents : null}
      >
        {isEditMode
          ? selectedStudents.filter((student) => student.is_new).length
          : selectedStudents.length}
        명 추가하기
      </button>
      <div
        style={{
          borderRadius: "5px",
          overflow: "auto",
          maxHeight: "470px",
        }}
      >
        {/* 테이블 헤더 */}
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <colgroup>
            <col style={{ width: "20%" }} />
            <col style={{ width: "20%" }} />
            <col />
            <col style={{ width: "10%" }} />
          </colgroup>
          <thead>
            <tr
              style={{
                borderBottom: "1px solid #EBEBEB",
                textAlign: "left",
                top: 0,
                zIndex: 1,
              }}
            >
              <td style={{ padding: "10px", textAlign: "center" }}>
                {/* 전체 선택/해제 체크박스 */}
                {handleSelectAllStudent && (
                  <CustomCheckbox
                    checked={selectedStudents.length > 0}
                    onChange={(e) => handleSelectAllStudent(e.target.checked)}
                  />
                )}
              </td>
              <td style={{ padding: "10px" }}>학년</td>
              <td style={{ padding: "10px" }}>이름</td>
            </tr>
          </thead>
          <tbody style={{ color: "black", fontSize: "18px" }}>
            {selectedStudents.map((student) => (
              <tr key={student.id}>
                <td style={{ padding: "10px", textAlign: "center" }}>
                  <CustomCheckbox
                    checked={selectedStudents.some((s) => s.id === student.id)}
                    onChange={(e) => handleSelectStudent(student)}
                  />
                </td>
                <td style={{ padding: "10px" }}>{showGrade(student.grade)}</td>
                <td style={{ padding: "10px" }}>{student.name}</td>
                <td style={{ color: "red" }}>
                  {student.is_new == false && <ErrorIcon fontSize="medium" />}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SelectedStudentList;
